import { recentWishListsStyles } from "@insite/content-library/Widgets/Common/RecentWishLists";
import { css } from "styled-components";

recentWishListsStyles.noWishListsText = {
    css: css`
        display: block;
        width: 100%;
        text-align: center;
    `,
};
